module.exports = __webpack_public_path__ + "static/media/iPhone 8.c5d2e973.jpg";